const DEFAULT_CARD_CLASSES = [
  'relative',
  'rounded-lg',
  'border',
  'border-grey-2',
  'text-slate-500',
  'overflow-x-clip',
  'overflow-y-visible'
].join(' ');

import { ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  className?: string;
  enableShadow?: boolean;
  useDefaultCardStyles?: boolean;
}

export function Card({
  enableShadow = false,
  className = '',
  children,
  useDefaultCardStyles = true,
  ...props
}: CardProps) {
  const shadowClass = enableShadow ? 'shadow-md' : '';

  return (
    <div
      {...props}
      className={`${useDefaultCardStyles ? DEFAULT_CARD_CLASSES : ''} ${shadowClass} ${className}`}>
      {children}
    </div>
  );
}
